import React from 'react'
import { 
    FormPassword
 } from './index';

const UserAccountForm = (props) => {
    const _displayMode = true;
    return(
        <div style={{ width: "50%", margin:"auto", textAlign:"left"}}>
            <FormPassword 
                labelName = "現在のパスワード"
                onChange={props.inputOldPassword} 
                value={props.loginUserAccount.oldPassword}
                className="oldPassword"
                displayMode={_displayMode}/>        
            <FormPassword 
                labelName = "変更後パスワード"
                onChange={props.inputPassword} 
                value={props.loginUserAccount.password[0]}
                className="password"
                displayMode={_displayMode}/>

            <FormPassword 
                labelName = "変更後パスワード（確認用）"
                onChange={props.inputConfirmPassword} 
                value={props.loginUserAccount.password[1]}
                className="password"
                displayMode={_displayMode}/>
        </div>
    )
}

export default UserAccountForm;